<template>
<div id="divlic" class="demo">
    <div class="seccion-01 imagen_licenciatura03 " :style="'background-color:'+Oferta.Color+';'">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-3 col-lg-5 col-xl-4 alinacion_img_licenciatura04">
                    <div class="box-img-lic">
                        <div class="overlay-lic" :style="'background-color:'+Oferta.Color+';'"></div>
                        <img :src="Oferta.RutaFile+Oferta.Imagen" alt="ENES">
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-11 col-lg-7 col-xl-8">
                    <div class="row">
                        <div class="col-10">
                            <h1 class="family-01"> {{Oferta.Titulo}}</h1>
                        </div>
                        <div class="col-2 mt-4">
                            <div class="row icon-position">
                                <div class="col-6">
                                    <a href="ldygi.html"><img src="../../assets/style/images/iconos/ico_enes_15.png" class="ico_15" alt=""></a>
                                </div>
                                <div class="col-6">
                                    <a href="lct.html"><img src="../../assets/style/images/iconos/ico_enes_14.png" class="ico_15" alt=""></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p>
                        <router-link :to="{name:'index',params:{}}">Inicio</router-link> / 
                        <router-link :to="{name:'ladmision',params:{}}">Licenciaturas</router-link> /
                        <a href="#">{{Oferta.Link}}</a>
                    </p>
                </div>
            </div>
        </div>
    </div>

    <section class="container justify-content-center">
        <div class="bg-principal">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 shadow_principal">
                    <div class="nav flex-column nav-pills bolt mt-4 mb-5" id="v-pills-tab" role="tablist"
                        aria-orientation="vertical">
                        <a class="nav-link active" id="v-pills-01-tab" data-toggle="pill" href="#v-pills-01" role="tab"
                            aria-controls="v-pills-01" aria-selected="true">
                            Introducción
                        </a>
                        <a class="nav-link" id="v-pills-02-tab" data-toggle="pill" href="#v-pills-02" role="tab"
                            aria-controls="v-pills-02" aria-selected="false">
                            Objetivo
                        </a>
                        <a class="nav-link" id="v-pills-03-tab" data-toggle="pill" href="#v-pills-03" role="tab"
                            aria-controls="v-pills-03" aria-selected="false">
                            Pertinencia Regional
                        </a>
                        <a class="nav-link" id="v-pills-04-tab" data-toggle="pill" href="#v-pills-04" role="tab"
                            aria-controls="v-pills-04" aria-selected="false">
                            Perfil de Ingreso
                        </a>
                        <a class="nav-link" id="v-pills-05-tab" data-toggle="pill" href="#v-pills-05" role="tab"
                            aria-controls="v-pills-05" aria-selected="false">
                            Perfil de Egreso
                        </a>
                        <a class="nav-link" id="v-pills-06-tab" data-toggle="pill" href="#v-pills-06" role="tab"
                            aria-controls="v-pills-06" aria-selected="false">
                            Campo Laboral
                        </a>
                        <a class="nav-link" id="v-pills-07-tab" data-toggle="pill" href="#v-pills-07" role="tab"
                            aria-controls="v-pills-07" aria-selected="false">
                            Plan de Estudios
                        </a>
                        <a class="nav-link" id="v-pills-08-tab" data-toggle="pill" href="#v-pills-08" role="tab"
                            aria-controls="v-pills-08" aria-selected="false">
                            Coordinación
                        </a>
                    </div>
                </div>

                <div class="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9">  
                    <div class="tab-content mt-4 mb-5" id="v-pills-tabContent">
                        <div class="tab-pane fade show active" id="v-pills-01" role="tabpanel"
                            aria-labelledby="v-pills-01-tab">
                            <CIntroduccion :licenciatura="licenciatura"></CIntroduccion>
                        </div>
                        <div class="tab-pane fade" id="v-pills-02" role="tabpanel" aria-labelledby="v-pills-02-tab">
                            <CBodyL :arrayDetalle="objTab1" :arrayIconos="listIconos" :Rutas="Rutas"></CBodyL>
                        </div>
                        <div class="tab-pane fade" id="v-pills-03" role="tabpanel" aria-labelledby="v-pills-03-tab">
                            <CBodyL :arrayDetalle="objTab2" :arrayIconos="listIconos" :Rutas="Rutas"></CBodyL>
                        </div>
                        <div class="tab-pane fade" id="v-pills-04" role="tabpanel" aria-labelledby="v-pills-04-tab">
                            <CBodyL :arrayDetalle="objTab3" :arrayIconos="listIconos" :Rutas="Rutas"></CBodyL>
                        </div>
                        <div  class="tab-pane fade" id="v-pills-05" role="tabpanel" aria-labelledby="v-pills-05-tab">
                            <CBodyL :arrayDetalle="objTab4" :arrayIconos="listIconos" :Rutas="Rutas"></CBodyL>
                        </div>
                        <div  class="tab-pane fade" id="v-pills-06" role="tabpanel" aria-labelledby="v-pills-06-tab">
                            <CBodyL :arrayDetalle="objTab5" :arrayIconos="listIconos" :Rutas="Rutas"></CBodyL>
                        </div>
                        <div  class="tab-pane fade" id="v-pills-07" role="tabpanel" aria-labelledby="v-pills-07-tab">
                            <CBodyL :arrayDetalle="objTab6" :arrayIconos="listIconos" :Rutas="Rutas"></CBodyL>
                        </div>
                        <div class="tab-pane fade" id="v-pills-08" role="tabpanel" aria-labelledby="v-pills-08-tab">
                            <CBodyL :arrayDetalle="objTab7" :arrayIconos="listIconos" :Rutas="Rutas"></CBodyL>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import CIntroduccion from './componentes/Introduccion';
import CBodyL from './componentes/bodyLicencia';


export default {
    name:'licenciatura',
    props:["pOferta","id"],
    components:{
        CIntroduccion,
        CBodyL
    },
    data() {
        return {
            Oferta:{
                Color:'#34508e',
                IdLigaInteres:0,
            },
            licenciatura:{
            },
            objTab1:{ ListaDet: [], },
            objTab2:{ ListaDet: [], },
            objTab3:{ ListaDet: [], },
            objTab4:{ ListaDet: [], },
            objTab5:{ ListaDet: [], },
            objTab6:{ ListaDet: [], },
            objTab7:{ ListaDet: [], },
            listIconos: [],
            Rutas:{
                RutaFile: '',
                RutaFileD: '',
            }
        }
    },
    methods: {
        async get_secciones(Apartado)
        {
            await this.$http.get(
                'inicio/licenciatura/',
                {
                    params:{ Apartado:Apartado,IdLigaInteres: this.Oferta.IdLigaInteres}
                }
            ).then( (res) => {
                this.licenciatura = res.data.data;
                this.Oferta = res.data.liga;
            });

            let IdOf = this.Oferta.IdLigaInteres;
            await this.$http.get('inicio/investigacion', {
					params:{Seccion:'LICENCIATURA'+IdOf,TxtBusqueda:'',Entrada:'',pag:'',RegEstatus: 'A',Orden:'SI'}
                }
            ).then((res) => {
                this.Rutas.RutaFile   = res.data.RutaFile;
                this.Rutas.RutaFileD  = res.data.RutaFileD;
                this.listIconos = res.data.listIconos;
                
                let newObj1 = [];
                let newObj2 = [];
                let newObj3 = [];
                let newObj4 = [];
                let newObj5 = [];
                let newObj6 = [];
                let newObj7 = [];

                $.each(res.data.tema, function(key, value)
                {
                    if(value.Apartado == 'OBJETIVO')        {   newObj1.push(value) }
                    else if(value.Apartado == 'PERTINENCIA'){   newObj2.push(value) }
                    else if(value.Apartado == 'INGRESO')    {   newObj3.push(value) }
                    else if(value.Apartado == 'EGRESO')     {   newObj4.push(value) }
                    else if(value.Apartado == 'LABORAL')    {   newObj5.push(value) }
                    else if(value.Apartado == 'PLAN')       {   newObj6.push(value) }
                    else if(value.Apartado == 'CONTACTO')   {   newObj7.push(value) }          
                });

                if(newObj1.length > 0){ this.objTab1.ListaDet = newObj1; }
                if(newObj2.length > 0){ this.objTab2.ListaDet = newObj2; }
                if(newObj3.length > 0){ this.objTab3.ListaDet = newObj3; }
                if(newObj4.length > 0){ this.objTab4.ListaDet = newObj4; }
                if(newObj5.length > 0){ this.objTab5.ListaDet = newObj5; }
                if(newObj6.length > 0){ this.objTab6.ListaDet = newObj6; }
                if(newObj7.length > 0){ this.objTab7.ListaDet = newObj7; }
            });
        },
        /*get_ActTab(tipo)
        {
            this.tabA=true;
            this.tabB=false;
            this.tabC=false;
            this.tabD=false;
            this.tabE=false;
            this.tabF=false;
            this.tabG=false;
            this.tabH=false;

            if(tipo=='LABORAL'){
                this.tabF=true;
            }
            window.scrollTo(0, 0);
        }*/
    },
    created()
    {
        if(this.id!=undefined){
            sessionStorage.setItem("id",JSON.stringify(this.id));
        }
        this.Oferta.IdLigaInteres = JSON.parse(sessionStorage.getItem('id'));
    },
    mounted() {
        this.get_secciones("PRESENTACION");
        window.scrollTo(0, 0);
    },
    destroyed() {
        sessionStorage.removeItem('id');
    },
}
</script>